<template>
    <article class="card-wrapper">
        <h4 class="card-title mb-2 text-xs fw-normal text-muted" v-if="title">{{ title }}</h4>
        <div class="card" :class="classes">
            <div class="card-body" :class="{ 'p-0': noPadding }">
                <slot></slot>
            </div>
        </div>
    </article>
</template>

<script>
export default {
    name: 'Card',
    props: {
        title: String,
        color: {
            type: String,
            validator: function (value) {
                return ['light'].includes(value)
            }
        },
        noPadding: Boolean
    },
    computed: {
        classes: function() {
            return [
                { 'bg-light': this.color === 'light' }
            ]
        }
    }
}
</script>
